module.exports = __webpack_public_path__ + "static/media/banner_hausaustellung.0641d9a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/highlight/banner_hausaustellung.png
// module id = 175
// module chunks = 0